import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetLocationByIdQueryVariables = Types.Exact<{
  locationId: Types.Scalars['bigint']['input'];
  customerId: Types.Scalars['bigint']['input'];
}>;


export type GetLocationByIdQuery = { __typename?: 'query_root', locations: Array<{ __typename?: 'locations', id: number, active: number, address?: string | null, address_line_one?: string | null, address_line_two?: string | null, city?: string | null, state?: string | null, zip_code?: string | null, createdat?: string | null, customer_id?: number | null, email?: string | null, favorite: boolean, latitude?: number | null, longitude?: number | null, name?: string | null, nickname?: string | null, phone?: string | null, place_id?: string | null, region_id?: number | null, timezone?: string | null, tookan_id?: number | null, type: string, updatedat?: string | null, customer?: { __typename?: 'customers', active: number, address?: string | null, config?: object | null, email?: string | null, id: number, name?: string | null, phone?: string | null, createdat?: string | null, updatedat?: string | null } | null }> };


export const GetLocationByIdDocument = gql`
    query getLocationById($locationId: bigint!, $customerId: bigint!) {
  locations(where: {id: {_eq: $locationId}, customer_id: {_eq: $customerId}}) {
    id
    active
    address
    address_line_one
    address_line_two
    city
    state
    zip_code
    createdat
    customer_id
    customer {
      active
      address
      config
      email
      id
      name
      phone
      createdat
      updatedat
    }
    email
    favorite
    latitude
    longitude
    name
    nickname
    phone
    place_id
    region_id
    timezone
    tookan_id
    type
    updatedat
  }
}
    `;

/**
 * __useGetLocationByIdQuery__
 *
 * To run a query within a React component, call `useGetLocationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationByIdQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetLocationByIdQuery(baseOptions: Apollo.QueryHookOptions<GetLocationByIdQuery, GetLocationByIdQueryVariables> & ({ variables: GetLocationByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationByIdQuery, GetLocationByIdQueryVariables>(GetLocationByIdDocument, options);
      }
export function useGetLocationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationByIdQuery, GetLocationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationByIdQuery, GetLocationByIdQueryVariables>(GetLocationByIdDocument, options);
        }
// @ts-ignore
export function useGetLocationByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLocationByIdQuery, GetLocationByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetLocationByIdQuery, GetLocationByIdQueryVariables>;
export function useGetLocationByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationByIdQuery, GetLocationByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetLocationByIdQuery | undefined, GetLocationByIdQueryVariables>;
export function useGetLocationByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationByIdQuery, GetLocationByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationByIdQuery, GetLocationByIdQueryVariables>(GetLocationByIdDocument, options);
        }
export type GetLocationByIdQueryHookResult = ReturnType<typeof useGetLocationByIdQuery>;
export type GetLocationByIdLazyQueryHookResult = ReturnType<typeof useGetLocationByIdLazyQuery>;
export type GetLocationByIdSuspenseQueryHookResult = ReturnType<typeof useGetLocationByIdSuspenseQuery>;
export type GetLocationByIdQueryResult = Apollo.QueryResult<GetLocationByIdQuery, GetLocationByIdQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/locations/queries/getLocationById.query.gql}
 */
export async function getLocationById(
  variables: GetLocationByIdQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetLocationByIdQuery['locations']>
export async function getLocationById(
  variables: GetLocationByIdQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetLocationByIdQuery>
export async function getLocationById(
  variables: GetLocationByIdQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetLocationByIdQuery['locations'] | GetLocationByIdQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetLocationByIdQuery>(
    GetLocationByIdDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.locations
}